import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "fixed inset-0 z-10 overflow-y-auto" }
const _hoisted_4 = { class: "min-h-screen px-4 text-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  class: "inline-block h-screen align-middle",
  "aria-hidden": "true"
}, " ​ ", -1)
const _hoisted_6 = { class: "inline-block w-full md:max-w-2xl p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogOverlay = _resolveComponent("DialogOverlay")!
  const _component_TransitionChild = _resolveComponent("TransitionChild")!
  const _component_DialogTitle = _resolveComponent("DialogTitle")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_TransitionRoot = _resolveComponent("TransitionRoot")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: _normalizeClass(_ctx.buttonClass || 'primary-button'),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args))),
        disabled: _ctx.isOpen
      }, [
        _renderSlot(_ctx.$slots, "button")
      ], 10, _hoisted_2)
    ]),
    _createVNode(_component_TransitionRoot, {
      appear: "",
      show: _ctx.isOpen,
      as: "template"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Dialog, {
          as: "div",
          onClose: _ctx.closeModal
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_TransitionChild, {
                  as: "template",
                  enter: "duration-300 ease-out",
                  "enter-from": "opacity-0",
                  "enter-to": "opacity-100",
                  leave: "duration-200 ease-in",
                  "leave-from": "opacity-100",
                  "leave-to": "opacity-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DialogOverlay, { class: "fixed inset-0 bg-gray-300 bg-opacity-40 backdrop-filter backdrop-blur" })
                  ]),
                  _: 1
                }),
                _hoisted_5,
                _createVNode(_component_TransitionChild, {
                  as: "template",
                  enter: "duration-300 ease-out",
                  "enter-from": "opacity-0 scale-95",
                  "enter-to": "opacity-100 scale-100",
                  leave: "duration-200 ease-in",
                  "leave-from": "opacity-100 scale-100",
                  "leave-to": "opacity-0 scale-95"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_DialogTitle, {
                        as: "h3",
                        class: "text-lg font-medium leading-6 text-gray-900 mb-2"
                      }, {
                        default: _withCtx(() => [
                          _renderSlot(_ctx.$slots, "modalTitle")
                        ]),
                        _: 3
                      }),
                      _renderSlot(_ctx.$slots, "modalContent")
                    ])
                  ]),
                  _: 3
                })
              ])
            ])
          ]),
          _: 3
        }, 8, ["onClose"])
      ]),
      _: 3
    }, 8, ["show"])
  ], 64))
}